import LuckyDrawDetail from "./luckyDrawDetail.container";

export default LuckyDrawDetail;
